import { render, staticRenderFns } from "./tryher-card-basic.vue?vue&type=template&id=ed6bb56a&scoped=true&"
import script from "./tryher-card-basic.vue?vue&type=script&lang=js&"
export * from "./tryher-card-basic.vue?vue&type=script&lang=js&"
import style0 from "./tryher-card-basic.vue?vue&type=style&index=0&id=ed6bb56a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6bb56a",
  null
  
)

export default component.exports